import { catalogOpsClient } from '~/api/client';
import { endpoints } from '~/api/endpoints';

/**
 * `POST /workflow/v1/enrichments/jobs/{jobId}/archive` — archives an
 * enrichment job. Used by the zero-eligible-products restart guard to
 * abandon the current run before sending the operator back to product
 * selection.
 */
export interface ArchiveEnrichmentJobPayload {
  /** Free-form audit string carried alongside the archive action. */
  reason: string;
}

export async function archiveEnrichmentJob(
  jobId: string,
  payload: ArchiveEnrichmentJobPayload,
): Promise<void> {
  await catalogOpsClient.post(endpoints.catalogOperations.archiveBatch(jobId), { json: payload });
}
